var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
export class StudyRecruitmentManager {
    constructor(authManager, studyService, fullRecordService, organizationsManager) {
        this.authManager = authManager;
        this.studyService = studyService;
        this.fullRecordService = fullRecordService;
        this.organizationsManager = organizationsManager;
        this.studyToRecruitmentMap = new Map();
    }
    async loadRecruitmentForStudy(studyId) {
        if (!this.authManager.orgId)
            return;
        const recruitment = await this.studyService.getRecruitment(this.authManager.orgId, studyId);
        if (recruitment) {
            this.studyToRecruitmentMap.set(studyId, recruitment);
        }
    }
    get isDataUser() {
        return this.authManager.isDataUser;
    }
    getRecruitmentForStudy(studyId) {
        var _a;
        return (_a = this.studyToRecruitmentMap.get(studyId)) !== null && _a !== void 0 ? _a : null;
    }
    async getIdentifiedPatientSummary(studyId) {
        if (!this.authManager.orgId)
            return null;
        return await this.studyService.getIdentifiedPatientSummary(this.authManager.orgId, studyId);
    }
    async getIdentifiedPatients(studyId, searchInput) {
        if (!this.authManager.orgId)
            return null;
        return await this.studyService.getIdentifiedPatients(this.authManager.orgId, studyId, searchInput);
    }
    async downloadFullRecords(studyId) {
        if (!this.authManager.orgId) {
            return null;
        }
        const resp = await this.studyService.getIdentifiedPatients(this.authManager.orgId, studyId, {});
        return this.fullRecordService.downloadZip(resp.patients, studyId);
    }
    async downloadIdentifiedFullRecords(studyId) {
        if (!this.authManager.orgId) {
            return null;
        }
        const resp = await this.studyService.getIdentifiedPatients(this.authManager.orgId, studyId, {});
        return this.fullRecordService.downloadIdentifiedZip(resp.patients, studyId);
    }
    async updateRecruitmentForStudy(studyId, input) {
        if (!this.authManager.orgId) {
            return null;
        }
        const searchResult = await this.studyService.updateRecruitment(this.authManager.orgId, studyId, input);
        await this.loadRecruitmentForStudy(studyId);
        return searchResult;
    }
    async updateIdentifiedPatientForStudy(studyId, organizationId, patientId, input) {
        if (!this.authManager.orgId) {
            return;
        }
        await this.studyService.updateIdentifiedPatient(this.authManager.orgId, studyId, organizationId, patientId, input);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], StudyRecruitmentManager.prototype, "studyToRecruitmentMap", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], StudyRecruitmentManager.prototype, "isDataUser", null);
